import {h} from 'preact';

const Programming = () => {
 return (
  <div className="service-list">
    <ul className="list">
      <li>Web programming</li>
      <li>Desktop application development</li>
      <li>Mobile application development</li>
      <li>Database design and optimization</li>
      <li>Data analysis and reports</li>
      <li>Computer networking and cybersecurity</li>
      <li>3D CAD modeling</li>
      <li>Algorithms</li>
    </ul>
  </div>
 );
};

export default Programming;
